export enum PurchaseOrderColumnHeader {
  PURCHASE_ORDER = "Purchase\u00A0Order\u00A0#",
  MAIN_PURCHASE_ORDER = "Main\u00A0PO\u00A0#",
  SUB_PO_STATUS = "Sub\u00A0PO\u00A0Status",
  SUB_PURCHASE_ORDERS = "Sub\u00A0POs",
  CONFIRMATION_STATUS = "Confirmation\u00A0Status",
  TRACKING_NUMBER = "Tracking\u00A0Number",
  CARRIER_STATUS = "Carrier\u00A0Status",
  CHECK_IN_STATUS = "Check\u2011in\u00A0Status",
  COMPLETION_STATUS = "Completion\u00A0Status",
  FULFILMENT_COMPLETION = "Fulfilment\u00A0&\u00A0Completion",
  ESTIMATED_DELIVERY_DATE = "Est.\u00A0Delivery",
  EST_COLLECTION_DATE = "Est.\u00A0Collection",
  SHIP_DATE = "Ship\u00A0Date",
  LAST_RECEIPT = "Last\u00A0Receipt",
  VENDOR = "Vendor",
  ORIGIN = "Origin",
  ASN = "ASN",
  COST = "Cost (£)",
  HMRC_COST = "HMRC Cost (£)",
  SENDER_EMAIL = "Sender\u00A0Email",
  OPS_NOTE = "Ops\u00A0Note",
  INVOICE_AT = "Invoice\u00A0At",
  LAST_UPDATE = "Last\u00A0Update",
  CREATION_DATE = "Creation\u00A0Date",
  EU_VS_EXPECTED = "EU\u00A0Qty\u00A0/\u00A0Expected",
  EU_VS_GXO = "EU\u00A0Qty\u00A0/\u00A0GXO\u00A0(EU)",
  CASE_VS_EU = "Case\u00A0Qty\u00A0/\u00A0EU\u00A0Qty",
  LAST_GXO_CHECK_IN = "Last\u00A0GXO\u00A0Check-In",
  LAST_EU_CHECK_IN = "Last\u00A0EU\u00A0Check-In",
  ACTIONS = "Actions"
  // VENDOR_EMAILS = "Vendor\u00A0Email(s)",
  // MORE_INFO = "More\u00A0Info",
  // PURCHASE_ORDER_PDF = "PO\u00A0File",
  // INVOICE = "Invoice",
  // AMEND = "Amend",
  // UPDATE_SHIPMENT_DETAILS = "Shipment\u00A0Details",
  // PARCEL_HERO_TIMELINE = "Parcel\u00A0Hero\u00A0Timeline"
}

export enum TransitPurchaseOrderColumnHeader {
  PURCHASE_ORDER = "Purchase\u00A0Order\u00A0#",
  TRANSIT_STATUS = "Transit\u00A0Status",
  CONFIRMATION_STATUS = "Confirmation\u00A0Status",
  COMPLETION_STATUS = "Completion\u00A0Status",
  TRACKING_LINK = "Tracking\u00A0Link",
  ESTIMATED_DELIVERY_DATE = "Est.\u00A0Delivery",
  ACTUAL_DELIVERY_DATE = "Actual\u00A0Delivery",
  FULFILMENT_COMPLETION = "Fulfilment\u00A0&\u00A0Completion",
  ACTION = "Action",
  MATCH_STATUS = "Match\u00A0Status",
  POTENTIAL_MATCHES = "Potential\u00A0Matches",
  VENDOR = "Vendor",
  SENDER_EMAIL = "Sender\u00A0Email",
  ACTIONS = "Actions"
}

export enum WarehouseCheckInColumnHeader {
  CHECK_IN_ID = "Check-in\u00A0Id",
  TIMESTAMP = "Timestamp",
  STATUS = "Status",
  ASN = "ASN",
  VENDOR = "Vendor",
  ORIGIN = "Origin",
  DESCRIPTION = "Description",
  CHECK_IN_EMAIL = "Check-in\u00A0Email",
  ORDER_SENDER_EMAIL = "Ops Email",
  MORE_INFO = "More Info",
  IMAGE = "Image",
  UPDATED_AT = "Updated\u00A0At",
  OPS_NOTE = "Ops\u00A0Note",
  ACTIONS = "Actions"
}

export enum ActiveAntsWarehouseCheckInColumnHeader {
  CHECK_IN_ID = "Check-in\u00A0Id",
  TIMESTAMP = "Timestamp",
  STATUS = "Status",
  TYPE = "Type",
  REFERENCE = "AA Reference",
  INBOUND_PACKING_SLIP = "Packing Slip",
  COMPLETED_ON = "Completed\u00A0On",
  ACTIONS = "Actions"
}

export enum ProductColumnHeader {
  ID = "Id",
  IMAGE = "Image",
  SKU = "SKU",
  NAME = "Name",
  UK_QTY = "UK Qty",
  EU_QTY = "EU Qty",
  ORDER_QUANTITY = "Order Qty",
  CONFIRMED_QTY = "Confirmed Qty",
  EST_RESTOCK_DATE = "Est Restock Date",
  QTY_DIFFERENCE = "Qty Difference",
  SIZE = "Size",
  BARCODE = "Barcode",
  REQUIRES_UK_RELABELLING = "UK Relabel",
  REQUIRES_EU_RELABELLING = "EU Relabel",
  IS_ANIMAL_SKU = "Animal",
  IS_ANIMAL_NON_CERTIFIED = "Animal (Non-Certified)",
  NEW_BARCODE = "New Barcode",
  EXTRA_INFO = "Extra Info",
  UNIT_COST = "Unit Cost (£)",
  HMRC_UNIT_COST = "HMRC Unit Cost (£)",
  PLACE_HOLDER = "",
  WAREHOUSE_LOG_QTY = "Warehouse Log Qty",
  CHILD_WAREHOUSE_LOG_QTY = "Child Warehouse Log Qty",
  RECEIVED_QTY = "Received Qty",
  TYPE = "Type",
  EU_RECEIVED = "EU\u00A0Received",
  STATUS = "Status"
}

export enum ProductCheckInColumnHeader {
  PRODUCT_ID = "ID",
  PRODUCT_NAME = "Product Name",
  PRODUCT_SKU = "SKU",
  PRODUCT_BARCODE = "Product Barcode",
  EXPIRY_DATES = "Expiry Date",
  ORDER_QTY = "Order Quantity",
  RECEIVED_QTY = "Qty Received",
  CONFIRMED_QTY = "Confirmed Qty"
}

export enum NonOrderProductCheckInColumnHeader {
  PRODUCT_ID = "ID",
  PRODUCT_NAME = "Product Name",
  PRODUCT_SKU = "SKU",
  PRODUCT_BARCODE = "Product Barcode",
  EXPIRY_DATES = "Expiry Date",
  RECEIVED_QTY = "Qty Received",
  PLACE_HOLDER = ""
}

export enum ProductDiscrepanciesColumnHeader {
  PRODUCT_ID = "Id",
  PRODUCT_NAME = "Product Name",
  PRODUCT_SKU = "SKU",
  ORDER_QTY = "Order Qty",
  CONFIRMED_ORDER_QTY = "Confirmed Qty",
  RECEIVED_QTY = "Received Qty",
  QTY_DIFFERENCE = "Qty Difference",
  COST_VARIANCE = "Cost Variance (£)",
  DEFECTIVE_EXPIRY_DATE = "Defective Expiry Date"
}

export enum ShipmentUnitsColumnHeaderMetric {
  TYPE = "Type",
  QUANTITY = "Quantity",
  WEIGHT = "Weight (kg)",
  LENGTH = "Length (cm)",
  WIDTH = "Width (cm)",
  HEIGHT = "Height (cm)",
  PLACE_HOLDER = ""
}

export enum ShipmentUnitsColumnHeaderImperial {
  TYPE = "Type",
  QUANTITY = "Quantity",
  WEIGHT = "Weight (lbs)",
  LENGTH = "Length (in)",
  WIDTH = "Width (in)",
  HEIGHT = "Height (in)",
  PLACE_HOLDER = ""
}

export enum EmailColumnHeader {
  EMAIL = "Email",
  PLACE_HOLDER = ""
}

export enum UserColumnHeader {
  NAME = "Name",
  EMAIL = "Email",
  ROLE = "Role",
  STATUS = "Status",
  JOB_TITLE = "Job Title",
  SUPERVISORS = "Supervisor Emails",
  VENDOR_IDS = "Vendors",
  CREATED_BY_EMAIL = "Created By",
  CREATED_AT = "Created At",
  UPDATED_AT = "Last Updated",
  SIGNED_UP_AT = "Signed Up At",
  ACTIONS = "Actions"
}

export enum ClaimProductColumnHeader {
  PRODUCT_ID = "Product ID",
  PRODUCT_NAME = "Product Name",
  PRODUCT_SKU = "SKU",
  BARCODE = "Barcode",
  QUANTITY = "Quantity",
  QUANTITY_DAMAGED = "Claim Quantity",
  UNIT_PRICE = "Unit Price (£)",
  PLACE_HOLDER = ""
}

export enum ClaimColumnHeader {
  ID = "ID",
  ISSUE_TYPE = "Issue Type",
  STATUS = "Status",
  PURCHASE_ORDER_ID = "Purchase Order ID",
  VENDOR = "Vendor",
  CLAIM_TYPE = "Claim Type",
  URGENCY_LEVEL = "Urgency",
  WAREHOUSE_LOCATION = "Warehouse Location",
  SUBMITTED_BY = "Submitted By",
  SENDER_EMAIL = "Sender Email",
  CREATION_DATE = "Creation Date",
  LAST_UPDATE = "Last Update",
  ACTIONS = "Actions"
}

export enum ClaimNonOrderProductColumnHeader {
  PRODUCT_ID = "Product ID",
  CLAIM_QUANTITY = "Claim Quantity",
  EXTRA_INFO = "Extra Info",
  PLACE_HOLDER = ""
}

export enum VendorColumnHeader {
  NAME = "Vendor",
  LOCATION = "Location",
  PORTAL_ORDER = "Portal Orders",
  COLLECTION_ORDER = "Collection Orders",
  COLLECTION_TYPE = "Collection Type",
  PORTAL_ACCESS = "Portal Access",
  FILE_TYPE = "File Type",
  IS_PRO_FORMA = "Pro Forma",
  EMAILS = "Emails",
  INVOICE_NAME = "Invoice Name",
  PAYMENT_TERMS = "Payment Terms",
  INCO_TERMS = "Inco Terms",
  COUNTRY_OF_EXPORT = "Country of Export",
  CREATED_BY_EMAIL = "Created By",
  CREATED_AT = "Created At",
  UPDATED_AT = "Last Updated",
  ACTIONS = "Actions"
}

export enum DailyExportsColumnHeader {
  DATE = "Date",
  DOWNLOAD = "Download"
}

export enum CreatePOProductColumnHeader {
  PRODUCT_ID = "Product ID",
  UK_QTY = "UK Qty",
  EU_QTY = "EU Qty",
  EXTRA_INFO = "Extra Info (Optional)",
  ACTIONS = ""
}

export enum CreateTOProductColumnHeader {
  PRODUCT_ID = "Product ID",
  EU_QTY = "Transfer Qty",
  EXTRA_INFO = "Extra Info (Optional)",
  ACTIONS = ""
}

export enum TransferOrderColumnHeader {
  TRANSFER_ORDER = "Transfer\u00A0Order\u00A0#",
  COMPLETION_STATUS = "Completion\u00A0Status",
  PRODUCTS_COUNT = "Products\u00A0Count",
  CREATED_BY = "Created\u00A0By",
  CREATION_DATE = "Creation\u00A0Date",
  ACTIONS = "Actions"
}

export enum ActiveAntsPurchaseOrderColumnHeader {
  ACTIVE_ANTS_PURCHASE_ORDER = "AA\u00A0PO\u00A0#",
  STATUS = "Status",
  CHECK_IN_STATUS = "Check\u2011in\u00A0Status",
  SHIPMENT = "Shipment",
  PRODUCTS_COUNT = "Products\u00A0Count",
  COST = "Cost (\u00A3)",
  HMRC_COST = "HMRC Cost (\u00A3)",
  CREATION_DATE = "Creation\u00A0Date",
  ACTIONS = "Actions"
}

export enum RelabelCaseColumnHeader {
  CASE_ID = "Case\u00A0ID",
  PURCHASE_ORDER = "Purchase\u00A0Order",
  VENDOR = "Vendor",
  TYPE = "Type",
  CONTENTS = "Contents",
  UNITS = "Units",
  ROUTE_TO = "Route\u00A0To",
  STATUS = "Status",
  ACTIONS = "Action",
  OUTPUT = "Output"
}

export enum PalletColumnHeader {
  PALLET_ID = "Pallet\u00A0ID",
  STATUS = "Status",
  LOCATION = "Location",
  PO_IDS = "Purchase\u00A0Orders",
  ANIMAL = "Type",
  TOTAL_CASES = "Total\u00A0Cases",
  TOTAL_UNITS = "Total\u00A0Units",
  TOTAL_VALUE = "Total\u00A0Value",
  CREATION_DATE = "Created\u00A0At",
  ACTIONS = "Actions"
}

export enum ShipmentColumnHeader {
  SHIPMENT_ID = "Shipment\u00A0ID",
  STATUS = "Status",
  PALLET_IDS = "Pallets",
  ACTIVE_ANTS_PO = "Active\u00A0Ants\u00A0PO",
  TRACKING_NUMBER = "Tracking\u00A0Number",
  CARRIER = "Carrier",
  CARRIER_STATUS = "Carrier\u00A0Status",
  CARRIER_DELIVERY_DATE = "Delivery\u00A0Date",
  COLLECTION_DATE = "Collection\u00A0Date",
  CREATION_DATE = "Created\u00A0At",
  ACTIONS = "Actions"
}

export enum RoutingCheckInColumnHeader {
  PRODUCT_ID = "ID",
  PRODUCT_NAME = "Product Name",
  PRODUCT_SKU = "SKU",
  PRODUCT_BARCODE = "Barcode",
  SIZE = "Size",
  EXPECTED_QTY = "Expected Qty",
  WAREHOUSE_RECEIVED = "Warehouse Received",
  PREV_RECEIVED = "Prev. Received",
  RECEIVE_NOW = "Receive Now"
}

export enum BrandSubmissionColumnHeader {
  BRAND = "Brand",
  PRODUCTS = "Products",
  SUBMITTED_BY = "Submitted\u00A0By",
  BP_OWNER = "BP\u00A0Owner",
  PDP = "PDP",
  COUNTRY_OF_ORIGIN = "Country\u00A0of\u00A0Origin",
  COMPLIANCE_CHECK_NEEDED = "Compliance\u00A0Check\u00A0Needed?",
  SUBMITTED_AT = "Submitted\u00A0At",
  STATUS = "Status",
  ACTIONS = "Actions",
  SHOPIFY = "Shopify"
}

export type ColumnHeader =
  | PurchaseOrderColumnHeader
  | TransitPurchaseOrderColumnHeader
  | WarehouseCheckInColumnHeader
  | ProductColumnHeader
  | ProductCheckInColumnHeader
  | NonOrderProductCheckInColumnHeader
  | ProductDiscrepanciesColumnHeader
  | ShipmentUnitsColumnHeaderMetric
  | ShipmentUnitsColumnHeaderImperial
  | EmailColumnHeader
  | UserColumnHeader
  | VendorColumnHeader
  | DailyExportsColumnHeader
  | ClaimProductColumnHeader
  | ClaimColumnHeader
  | ClaimNonOrderProductColumnHeader
  | CreatePOProductColumnHeader
  | RelabelCaseColumnHeader
  | PalletColumnHeader
  | ShipmentColumnHeader
  | BrandSubmissionColumnHeader
  | RoutingCheckInColumnHeader
  | CreateTOProductColumnHeader
  | TransferOrderColumnHeader
  | ActiveAntsPurchaseOrderColumnHeader
  | ActiveAntsWarehouseCheckInColumnHeader;
